import { useEffect, useState } from 'react';
import { loadPack, indexQuestions, type LoadPackOpts } from './loadPack';
import type { PackBundle, PackQuestion } from './types';

export interface UsePackResult {
  bundle: PackBundle | null;
  questionsById: Map<string, PackQuestion>;
  error: string | null;
}

// Loads the room's pack bundle the first time `packId` is known. Re-fetches
// on packId change; safe to call before MATCH_CREATED has arrived (returns
// empty state until then).
export function usePack(opts: LoadPackOpts & { packId: string | null }): UsePackResult {
  const [bundle, setBundle] = useState<PackBundle | null>(null);
  const [error, setError]   = useState<string | null>(null);

  useEffect(() => {
    if (!opts.packId || !opts.roomId || !opts.token) return;
    let cancelled = false;
    loadPack({
      apiBase: opts.apiBase,
      roomId:  opts.roomId,
      token:   opts.token,
      signKey: opts.signKey,
      fetcher: opts.fetcher,
    })
      .then((b) => { if (!cancelled) { setBundle(b); setError(null); } })
      .catch((e: unknown) => { if (!cancelled) setError((e as Error).message); });
    return () => { cancelled = true; };
  }, [opts.apiBase, opts.roomId, opts.packId, opts.token, opts.signKey]);

  return {
    bundle,
    questionsById: bundle ? indexQuestions(bundle) : new Map(),
    error,
  };
}
